
import { ValidateDec } from '@/decorators';
import { Component, Prop, Vue, Watch } from 'vue-facing-decorator'

const STYLE_LIST = [
  { value: 1, label: '经典红', colors: { '--primary-color': '#FF0000', '--secondary-color': '#F2EEE2' } },
  { value: 2, label: '优雅粉', colors: { '--primary-color': '#E84393', '--secondary-color': '#FDF2F8' } },
  { value: 3, label: '活力橙', colors: { '--primary-color': '#FF6B35', '--secondary-color': '#FFF3ED' } },
  { value: 4, label: '典雅紫', colors: { '--primary-color': '#6C5CE7', '--secondary-color': '#F0EDFF' } },
  { value: 5, label: '清新蓝', colors: { '--primary-color': '#0984E3', '--secondary-color': '#EBF5FF' } },
  { value: 6, label: '薄荷绿', colors: { '--primary-color': '#00B894', '--secondary-color': '#E6F9F4' } },
  { value: 7, label: '暖阳黄', colors: { '--primary-color': '#FDCB6E', '--secondary-color': '#FFF9E6' } },
];

@Component({})
export default class extends Vue {
  forms = {
    name: "",
    style: 1,
  }

  get STYLE_LIST() {
    return STYLE_LIST;
  }

  @ValidateDec("form")
  async submit() {
    let { error, message } = await this.$post('/manager/store/create', {
      name: this.forms.name,
      styles: this.forms.style,
    });
    if (error) return this.$error(message);
    this.$emit("resolve", {})
  }
  close() {
    this.$emit("reject", { msg: '取消' })
  }
}
